import { SxProps, Theme } from '@mui/material';

export const hintStyles: SxProps<Theme> = {
    mb: 2,
    color: 'text.secondary',
};

export const fieldStyles: SxProps<Theme> = {
    mb: 2,
};

export const formAlertStyles: SxProps<Theme> = {
    mb: 2,
};

export const actionsStyles: SxProps<Theme> = {
    display: 'flex',
    gap: 2,
    alignItems: 'center',
    flexWrap: 'wrap',
};
